import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {
    $('.pdp-cross-sell-product').hover(
        function () {
            $(this).closest('.pdp-cross-sell-product').toggleClass('hover');
        }
    );

    $('.pdp-cross-sell-product form, .pdp-cross-sell-product .form-holder').hover(
        function () {
            $(this).closest('.pdp-cross-sell-product').toggleClass('hover');
        }
    );

    $("select.single-option-selector").on('change', function () {
        const $selected = $(this).find("option:selected");
        const $card = $(this).closest('.pdp-cross-sell-product');
        const newIMG = $selected.attr('data-image');
        const price = $selected.attr('price');
        const compareAtPrice = parseInt($selected.attr('data-compare-price'), 10);
        const variantPrice = parseInt(price.replace(/[^0-9]/g, ''), 10);

        $card.find('.pdp-cross-sell-img-container img').attr("src", newIMG).attr("srcset", newIMG);

        if (price) {
            $card.find('[data-product-price]').text(price);
        }

        const $comparePrice = $card.find('.cross-sell-compare-price');
        if (compareAtPrice && compareAtPrice > variantPrice) {
            $comparePrice.text(window.Shopify.formatMoney(compareAtPrice, window.Shopify.money_format.replace("amount", "amount_no_decimals")));
            $comparePrice.addClass('shown');
        } else {
            $comparePrice.removeClass('shown');
        }
    });

    $('#pdp-cross-sell-slider').slick({
        prevArrow: '<span class="slick-arrow slick-previous"></span>',
        nextArrow: '<span class="slick-arrow slick-next"></span>',
        infinite: false,
        lazyLoad: 'ondemand',
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
